// api =>
import backEnd from "../../services/api";

export const getPortfolioList = async (categoryId) => {
    try {
        const response = await backEnd.get(`services/portfolios/?category=${ categoryId }`);
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}

export const getCategoryList = async () => {
    try {
        const response = await backEnd.get("services/categories/");
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}

export const getPortfolioStoryList = async (portfolioId) => {
    try {
        const response = await backEnd.get(`services/portfolios/${ portfolioId }/stories/`);
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}

export const getPortfolioImageList = async (portfolioId) => {
    try {
        const response = await backEnd.get(`services/portfolios/${ portfolioId }/images/`);
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}

export const getPortfolioVideoList = async (portfolioId) => {
    try {
        const response = await backEnd.get(`services/portfolios/${ portfolioId }/videos/`);
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}
